import React from 'react';
import * as Sentry from '@sentry/browser';

class SentryErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });

    if (process.env.NODE_ENV === 'production') {
      Sentry.withScope((scope) => {
        Object.keys(errorInfo).forEach((key) => {
          // eslint-disable-next-line security/detect-object-injection
          scope.setExtra(key, errorInfo[key]);
        });
        Sentry.captureException(error);
      });
    }
  }

  render() {
    if (this.state.error) {
      //render fallback UI
      return null;
    }
    //when there's not an error, render children untouched
    return this.props.children;
  }
}

export default SentryErrorBoundary;
